import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: "",
  loading: false,
}

export const StartDateSlice = createSlice({
  name: 'StartDate',
  initialState,
  reducers: {
   
    Start_Date_success: (state, action) => {

      state.value = action.payload;
      state.loading = false;
      
    },
  
  }
})

// Action creators are generated for each case reducer function
export const {Start_Date_success } = StartDateSlice.actions

export default StartDateSlice.reducer